import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatabaseDownstreamWorkbooksQueryVariables, DatabaseDownstreamWorkbooksQuery, WorkbooksDisplayGridRowDataFragment, DatabaseDownstreamWorkbooksFilteredByTableQueryVariables, DatabaseDownstreamWorkbooksFilteredByTableQuery, WorkbookSortOrder , DatabaseDownstreamWorkbooksFilteredByTableDocument , DatabaseDownstreamWorkbooksDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import {
  getRowDataForWorkbook,
  WorkbooksDisplayGrid,
  WorkbooksDisplayGridRowData
} from '../sharedDisplayGrid/WorkbooksDisplayGrid';
import { WorkbooksValidSortFields } from '../sorting/sortProviders/WorkbooksGridSortProvider';

type QueryVariables = DatabaseDownstreamWorkbooksQueryVariables;
type QueryResults = DatabaseDownstreamWorkbooksQuery;
type QueryResultListNode = WorkbooksDisplayGridRowDataFragment;
type GridRowData = WorkbooksDisplayGridRowData;

type QueryVariablesWithFilter = DatabaseDownstreamWorkbooksFilteredByTableQueryVariables;
type QueryResultsWithFilter = DatabaseDownstreamWorkbooksFilteredByTableQuery;
type QueryResultListNodeWithFilter = WorkbooksDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.databases && resultData.databases[0] &&
    resultData.databases[0].downstreamWorkbooksConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const table = resultData &&
    resultData.databases &&
    resultData.databases[0] &&
    resultData.databases[0].tables &&
    resultData.databases[0].tables[0];
  return table && table.downstreamWorkbooksConnection;
}


export type DatabaseDownstreamWorkbooksQueryGridProps =
  GridSortProps<WorkbooksValidSortFields> & {
    readonly databaseId: string;
    readonly filteredTableId: string | null;
    readonly rowCount: number | null;
  };

export function DatabaseDownstreamWorkbooksQueryGrid(props: DatabaseDownstreamWorkbooksQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamWorkbooksLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredWorkbooksLineageGridMessage();


  return (
    props.filteredTableId ? (
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNodeWithFilter, GridRowData>
        queryGql={DatabaseDownstreamWorkbooksFilteredByTableDocument}
        partialQueryVariables={{
          databaseId: props.databaseId,
          tableId: props.filteredTableId,
          orderBy: props.orderBy as WorkbookSortOrder
        }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForWorkbook}
      >
        {({ rowStore }) => <WorkbooksDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    ) : (
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={DatabaseDownstreamWorkbooksDocument}
        partialQueryVariables={{ databaseId: props.databaseId, orderBy: props.orderBy as WorkbookSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForWorkbook}
      >
        {({ rowStore }) => <WorkbooksDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    )
  )
}
